;
(function ($) {
    "use strict";

    if (!$('body.page-template-template-home').length) return false;

    function kill_state_names() {
        $('.state-name').remove();
    }

    $(document).ready(function () {
        $('body').on('mouseover');
        $('#map').usmap({
            stateStyles: {
                fill: '#c4cff1',
                'stroke': '#FFF',
                'stroke-width': 1
            },
            stateHoverStyles: {fill: '#1F5291'},
            stateHoverAnimation: 300,
            showLabels: true,
            useAllLabels: true,
            click: function (event, data) {
                const slug = window.member_page_slug;
                const url = '/' + slug + '/?state=' + data.name;

                window.location = url;
            },
            mouseover: function (event, data) {

                const pageX = event.originalEvent.pageX + 40;
                const pageY = event.originalEvent.pageY - 40;
                kill_state_names();
                const el = `<div class='state-name' style='position: absolute;top:${pageY}px;left:${pageX}px'>` + data.name + "</div>";
                $('body').append(el);
            },
            mouseout: function (event, data) {
                kill_state_names();
            }
        });
    });
})(jQuery);